import { render, staticRenderFns } from "./skuMemberPrice.vue?vue&type=template&id=51929760&"
import script from "./skuMemberPrice.vue?vue&type=script&lang=js&"
export * from "./skuMemberPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports